import { FC } from 'react';
import { Link } from 'react-router-dom';

const NotApprovedPage: FC = () => {
    return (
        <div className="min-h-screen bg-slate-900 flex flex-col justify-center items-center p-4">
            <div className="w-full max-w-md text-center">
                <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-8">
                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-sky-400 mx-auto mb-6"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
                    <h1 className="text-2xl font-bold text-white mb-4">Account in Attesa di Approvazione</h1>
                    <p className="text-slate-400 mb-6">
                        Grazie per esserti registrato. Il tuo account è stato confermato e ora è in attesa di approvazione da parte di un amministratore.
                    </p>
                    <p className="text-slate-500 text-sm">
                        Riceverai un'email non appena il tuo account sarà attivo.
                    </p>
                    <Link to="/login" className="mt-8 inline-block px-6 py-2 rounded-lg text-white font-semibold bg-slate-700 hover:bg-slate-600 transition-colors">
                        Torna al Login
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default NotApprovedPage;
